// Libraries
import { Header } from '../../components/';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// Components

// Styles
import './headerLayout.scss';

const HeaderLayout = ({ children }) => (
    <Fragment>
        <Header />
        <div className="headerlayout-content">{children}</div>
    </Fragment>
);

HeaderLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HeaderLayout;
